import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ClosedEyeIcon } from '../../assets/icon/components/ClosedEyeIcon';
import cn from 'classnames';
import './hiddenIcon.css';

interface HiddenIconProps {
  isHidden: boolean | undefined;
  tooltipText?: string;
  iconSize?: number;
  iconColor?: string;
  customClassName?: string;
}

export const HiddenIcon: React.FC<HiddenIconProps> = ({
  isHidden,
  tooltipText = 'Товар скрыт',
  iconSize = 20,
  iconColor = 'red',
  customClassName
}) => {
  if (isHidden !== true) {
    return null;
  }

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-hidden">{tooltipText}</Tooltip>}
    >
      <div className={cn(customClassName, 'hidden-icon')}>
        <ClosedEyeIcon width={iconSize} height={iconSize} color={iconColor} />
      </div>
    </OverlayTrigger>
  );
};
